import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import V2Footer from "@Components/V2Footer/V2Footer";
// Navbar is a shared component rather than a per-page copy, so the v2 pages keep
// one source of truth for the scroll/hover interactions. The document furniture —
// hero, body renderer and closing seal — is shared with /terms-v2.
import Navbar from "@Components/Navbar/Navbar";
import LegalHero from "@Components/LegalDoc/LegalHero";
import LegalDoc from "@Components/LegalDoc/LegalDoc";
import LegalSeal from "@Components/LegalDoc/LegalSeal";
import PRIVACY_CONTENT from "./content/policy";
import styles from "./PrivacyV2.module.scss";
import { CONTACT_URL, TERMS_URL } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import useIsApp from "hooks/useIsApp";

const PrivacyV2 = () => {
  const { t } = useTranslationHook();
  const isApp = useIsApp();

  return (
    <div className={styles.page}>
      {/* The live page's own meta keys — same document, same description. */}
      <Helmet title={t("privacy.meta.title")}>
        <meta name="description" content={t("privacy.meta.description")} />
        {/* Instrument Sans — the design font, loaded only on this page */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap"
        />
      </Helmet>

      <Navbar
        isAppHeader={isApp}
        links={[
          { label: "privacy.v2.navbar.terms", href: TERMS_URL },
          { label: "navbar.v2.support", href: CONTACT_URL },
        ]}
      />
      <LegalHero title={t("privacy.page.title")} subtitle={t("privacy.v2.hero.subtitle")} />
      <LegalDoc content={PRIVACY_CONTENT} />
      <LegalSeal />
      <V2Footer />
    </div>
  );
};

export default wrapperHOC(PrivacyV2, {
  componentName: "PrivacyV2-Page",
  showForChina: true,
});
